import React from 'react';
import { Tooltip } from '../../';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import { useTranslation } from 'react-i18next';

const IconButton = React.forwardRef(
  (
    {
      tooltip,
      icon,
      onClick,
      disabled,
      style,
      disabledTooltip,
      title,
      name,
      ...rest
    },
    ref,
  ) => {
    const { t } = useTranslation();
    const iconBtn = (
      <Button
        ref={ref}
        shape="circle"
        onClick={(e) => {
          if (!disabled && !isUndefined(onClick)) {
            onClick(e);
          }
        }}
        disabled={disabled}
        {...rest}
        size="large"
        icon={icon}
        style={style}
      >
        {name}
      </Button>
    );

    const wrappedButton = (
      <div className="icon-button-container">{iconBtn}</div>
    );

    if (tooltip) {
      if (!disabledTooltip)
        disabledTooltip = t('Študent už bol pridelený na projekt');
      return (
        <Tooltip tooltip={(!disabled && tooltip) || disabledTooltip}>
          {wrappedButton}
        </Tooltip>
      );
    }

    return wrappedButton;
  },
);

IconButton.displayName = 'IconButton';

IconButton.propTypes = {
  icon: PropTypes.node,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  disabledTooltip: PropTypes.string,
};

export default IconButton;
